var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('admin-layout',[_c('template',{slot:"content"},[_c('h2',{staticClass:"subpoenas-title mb-3"},[_vm._v("Intimações")]),_c('subpoenas',{attrs:{"isAdmin":true}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }